module.exports = __webpack_public_path__ + "img/ai1.9ed32bf8.png";